import CategoryApplicationsDrawer from "./CategoryApplicationsDrawer"

export default  CategoryApplicationsDrawer;
